// ANGULAR
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// GUARDS
import { AuthBusinessGuard } from '../core/guards/auth-business.guard';
import { AuthGuard } from '../core/guards/auth.guard';
import { SigninGuard } from '../core/guards/signin.guard';

// CONSTANTS
import { ROUTE_CONSTANTS } from '../constants/route';
import { PERMISSIONV2 } from '../constants/permissionv2/role-permission';

// PERMISSIONS
import { NgxPermissionsGuard } from 'ngx-permissions';

const routes: Routes = [
  {
    path: ROUTE_CONSTANTS.CONTAINER.AUTH,
    loadChildren: () => import('./main/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: ROUTE_CONSTANTS.PUBLIC.PUBLICFORM,
    loadChildren: () => import('./main/public-form/public-form.module').then((m) => m.PublicFormModule),
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.BUSINESS,
    loadChildren: () => import('./main/business/business.module').then((m) => m.BusinessModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.ONBOARDING,
    loadChildren: () => import('./main/onboarding/onboarding.module').then((m) => m.OnboardingModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.GETTING_STARTED,
    loadChildren: () => import('./main/getting-started/getting-started.module').then((m) => m.GettingStartedModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.GRAPHICS_PREVIEW,
    loadChildren: () => import('./main/graphics-preview/graphics-preview.module').then((m) => m.GraphicsPreviewModule),
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.NOTIFICATION_NAVIGATION,
    loadChildren: () => import('./main/notification-navigation/notification-navigation.module').then((m) => m.NotificationNavigationModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.NFC,
    loadChildren: () => import('./main/nfc/nfc.module').then((m) => m.NfcModule),
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.MAIN,
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
    canActivate: [AuthBusinessGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.LOGINAS,
    loadChildren: () => import('./login-as/login-as.module').then((m) => m.LoginAsModule),
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.INTEGRATIONS,
    loadChildren: () => import('./main/integrations/callback/callback.module').then((m) => m.CallbackModule),
  },
  {
    path: `${ROUTE_CONSTANTS.CONTAINER.ORDER_INVENTORY_PRINT}/:id`,
    loadComponent: () => import('./main/order-inventory/pages/order-print/order-print.component').then((m) => m.OrderPrintComponent),
    canActivate: [AuthBusinessGuard, NgxPermissionsGuard],
    data: { permissions: { only: PERMISSIONV2.ORDERS_ACCESS, redirectTo: ROUTE_CONSTANTS.UNAUTHORIZED_REDIRECT } },
  },
  { path: '**', pathMatch: 'full', redirectTo: ROUTE_CONSTANTS.CONTAINER.AUTH },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    CommonModule,
  ],
  exports: [RouterModule],
})
export class UiModulesRouting { }
